import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { ArticlesViewComponent } from '../../../Components/articles-view/articles-view.component';
import { BaseComponent } from '../../base.component';
import { IPopup } from '../../../Components/popup/popup.model';
import { SchoolApiService } from '../../../Services/schoolApi.service';
import { BAC_PAGES, DOMAIN_TYPE, SCHEMA_TYPE } from '../../../constants';
import { AutoUnsubscribe } from '../../../Services/autoUnsubscribe.service';
import { IList } from '../../../Models/list.model';
import { IResponse } from '../../../Models/response.model';
import { ISchoolArticle } from '../../../Models/schoolArticle.model';

@AutoUnsubscribe()
@Component({
  selector: 'app-bac-news',
  standalone: true,
  imports: [ArticlesViewComponent],
  providers: [SchoolApiService],
  templateUrl: './bac-news.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BacNewsComponent extends BaseComponent {
  public newsArticles: IPopup[] = [];
  public start: number = 0;
  public limit: number = 10;
  public totalcount: number;

  constructor(
    override readonly schoolApiService: SchoolApiService,
    readonly cdr: ChangeDetectorRef,
  ) {
    super(schoolApiService);
    this.domainType = DOMAIN_TYPE.BAC;
    this.schemaType = SCHEMA_TYPE.ARTICLE;
    this.articleType = BAC_PAGES.NEWS;
  }

  ngOnInit(): void {
    this.onPaginateEvent(0);
  }

  onPaginateEvent($event: number) {
    this.start = $event;
    this.schoolApiService
      .getSchoolArticles({
        domainType: this.domainType,
        schemaType: this.schemaType,
        filter: { articleType: this.articleType },
        isArchived: false,
        language: this.language,
        start: this.start,
        limit: this.limit,
      })
      .subscribe((data: IResponse<IList<ISchoolArticle>>) => {
        if (data.status) {
          this.totalcount = data.payload?.count || 0;
          this.newsArticles = this.mapArticles(data.payload?.list || []);
          this.cdr.detectChanges();
        }
      });
  }
}
